var map = {
	"./en": 49137,
	"./en.mjs": 49137,
	"./extra/en": 82450,
	"./extra/en.mjs": 82450,
	"./extra/it": 23282,
	"./extra/it.mjs": 23282,
	"./it": 4129,
	"./it.mjs": 4129
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | i18n-base */ "i18n-base").then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 91859;
module.exports = webpackAsyncContext;